import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { darkenOnHover } from '../styles/helpers/mixins';

const InstragramPost = props => {
  if (!props.url || !props.imageUrl) {
    return false;
  }

  return (
    <InstagramLink href={props.url} target="_blank">
      <InstragramImageContainer>
        <InstragramImage image={props.imageUrl} />
      </InstragramImageContainer>
    </InstagramLink>
  );
};

const InstagramLink = styled.a`
  ${darkenOnHover};
  display: block;
  font-size: 0;
`;

const InstragramImageContainer = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
`;

const InstragramImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("${props => props.image}");
  background-position: center;
  background-size: cover;
`;

InstragramPost.defaultProps = {
  url: null,
  imageUrl: null
};

InstragramPost.propTypes = {
  url: PropTypes.string,
  imageUrl: PropTypes.string
};

export default InstragramPost;



// WEBPACK FOOTER //
// ./src/components/InstagramPost.js